"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});

var _Grow = _interopRequireDefault(require("./Grow"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Grow/index.js
// module id = 226
// module chunks = 2